<template>
    <form @submit.prevent="save" class="clearfix pb-4">
        <top-nav-bar :goto="backPath"></top-nav-bar>

        <template v-if="step === 'information'">
            <form-group label="Summary" name="summary" :required="true">
                <input type="text" name="summary" class="input" v-model="report.summary">
            </form-group>

            <form-group label="Date" name="date" :required="true">
                <datepicker
                    placeholder="Select date"
                    id="date"
                    name="date"
                    :min-date="minStartDate"
                    v-model="report.date"
                />
            </form-group>

            <form-group label="Time" name="time" :required="true">
                <time-field
                    id="time"
                    class="input"
                    name="time"
                    v-model="report.time"
                />
            </form-group>

            <form-group label="Route" name="route" :required="true">
                <div class="select">
                    <select v-model="report.route" id="route" name="route" class="input">
                        <option value="">Select a Route</option>
                        <option v-for="route in routes" :value="route">
                            {{route}}
                        </option>
                    </select>
                </div>
            </form-group>

            <form-group label="Description" name="description" :required="true">
                <textarea name="description" class="input" id="description" rows="10" v-model="report.description"></textarea>
            </form-group>
        </template>

        <template v-if="step === 'details'">
            <h4>Details</h4>

            <form-group label="Time from Start of Duty" name="start_of_duty">
                <vue-slider
                    :tooltip="false"
                    :min="1"
                    :max="12"
                    :interval="1"
                    v-model="report.start_of_duty">
                </vue-slider>
                <input type="hidden" name="start_of_duty" v-model="report.start_of_duty">
                <div class="flex justify-end pt-2">
                    <span class="font-heading uppercase font-bold text-xs mr-2">
                        {{report.start_of_duty}} hours
                    </span>
                </div>
            </form-group>

            <form-group label="Time from Wake Up" name="wake_up">
                <vue-slider
                    :tooltip="false"
                    :min="1"
                    :max="12"
                    :interval="1"
                    v-model="report.wake_up">
                </vue-slider>
                <input type="hidden" name="wake_up" v-model="report.sleep">
                <div class="flex justify-end pt-2">
                    <span class="font-heading uppercase font-bold text-xs mr-2">
                        {{report.wake_up}} hours
                    </span>
                </div>
            </form-group>

            <form-group label="Length of Sleep During Previous Night" name="sleep">
                <vue-slider
                    :tooltip="false"
                    :min="1"
                    :max="20"
                    :interval="1"
                    v-model="report.sleep">
                </vue-slider>
                <input type="hidden" name="sleep" v-model="report.sleep">
                <div class="flex justify-end pt-2">
                    <span class="font-heading uppercase font-bold text-xs mr-2">
                        {{report.sleep}} hours
                    </span>
                </div>
            </form-group>

            <form-group label="Consecutive Days From Start of FDP" name="start_of_fdp">
                <vue-slider
                    :tooltip="false"
                    :min="1"
                    :max="7"
                    :interval="1"
                    v-model="report.start_of_fdp">
                </vue-slider>
                <input type="hidden" name="start_of_fdp" v-model="report.start_of_fdp">
                <div class="flex justify-end pt-2">
                    <span class="font-heading uppercase font-bold text-xs mr-2">
                    {{report.start_of_fdp > 6 ? '6+' : report.start_of_fdp}} days
                    </span>
                </div>
            </form-group>

            <form-group label="How alert did you feel from start of FDP?" name="alertness" :required="true">
                <input type="text" name="alertness" class="input" v-model="report.alertness">
            </form-group>

            <form-group label="Contributing factors to fatigue" name="factors" :required="true">
                <div class="text-sm text-grey-dark mb-2">Check all factors that may have contributed to your fatigue.</div>
                <label v-for="factor in factors" class="py-1">
                    <input type="checkbox" name="factors[]" v-model="report.factors" :value="factor">
                    <span class="font-body font-normal normal-case text-base ml-2">{{factor}}</span>
                </label>
            </form-group>

            <form-group label="Suggestions for future preventive actions" name="suggestions" :required="true">
                <textarea name="suggestions" class="input" id="suggestions" rows="10" v-model="report.suggestions"></textarea>
            </form-group>
        </template>

        <div class="block md:inline-flex md:float-right">
            <button class="btn btn--colored__blue w-full" type="submit" v-html="buttonText"></button>
        </div>
    </form>
</template>

<script>
import InteractsWithDates from '@/mixins/InteractsWithDates'
import NeedsUsers from '@/mixins/NeedsUsers'
import HasSteps from '@/mixins/HasSteps'
import IsReport from '@/mixins/IsReport'
import SetsReportData from '@/mixins/SetsReportData'
import vueSlider from 'vue-slider-component'
export default {
    components: {vueSlider},

    mixins: [InteractsWithDates, NeedsUsers, HasSteps, IsReport, SetsReportData],

    data() {
        return {
            type: 'fatigue',
            steps: [
                {name: 'Information', id: 'information'},
                {name: 'Details', id: 'details'},
            ],
            report: {
                summary: '',
                date: '',
                time: '',
                route: '',
                description: '',
                start_of_duty: 1,
                wake_up: 1,
                sleep: 1,
                start_of_fdp: 1,
                alertness: '',
                suggestions: '',
                factors: []
            }
        }
    },

    created() {
        if(this.$parent.reportData) {
            this.setData(this.$parent.reportData, 'date')
            this.setData(this.$parent.reportData, 'time', 'std')
            this.setData(this.$parent.reportData.content, ['description', 'route', 'summary'])
            this.setData(this.$parent.reportData.content, [
                'atd', 'aircraft_reg', 'crew_count_j_class', 'crew_count_y_class', 'j_class', 'y_class'
            ])
            this.setData(this.$parent.reportData.content, [
                'boarding_start', 'crew_at_aircraft', 'crew_documents_ok', 'door_closed',
                'first_service_end_j', 'first_service_end_y', 'first_service_start_jy',
                'second_service_end_j', 'second_service_end_y', 'second_service_start_jy',
            ], 'times')
            this.setData(this.$parent.reportData.content, [
                'closing_and_flight_feedback', 'crew_rest_acc_to_rules', 'onboard_sales', 'other_remarks', 'sales_report', 'uniform_grooming_check',
            ], 'remarks')
        }
    },

    computed: {
        routes() {
            return this.$parent.routes
        },

        factors() {
            return this.$parent.factors
        }
    },
}
</script>
